import { EquipmentIdentifiers } from '@/features/equipment-browser/types';

import {
  DeviceDetailsAnalyticsAttributes,
  useEquipmentDetailsRouteState,
} from './use-equipment-details-route-state';

export type { DeviceDetailsAnalyticsAttributes };

export const useSelectEquipment = () => {
  const {
    closeEquipmentDetails,
    equipmentId,
    openEquipmentDetails,
    sectionId,
    selectNextEquipment,
    selectPreviousEquipment,
    updateEquipmentDetailsSearch,
    viewId,
  } = useEquipmentDetailsRouteState();

  const updateSearchParams = async (newIdentifiers: EquipmentIdentifiers) => {
    await updateEquipmentDetailsSearch({
      viewId: newIdentifiers.viewId,
      sectionId: newIdentifiers.sectionId,
      equipmentId: newIdentifiers.equipmentId,
    });
  };

  const selectEquipmentAction = async (
    nextEquipmentId?: string,
    nextSectionId?: string,
    nextViewId?: string,
    analyticsAttributes?: DeviceDetailsAnalyticsAttributes
  ) => {
    const resolvedEquipmentId = nextEquipmentId ?? equipmentId;
    if (!resolvedEquipmentId) {
      await updateEquipmentDetailsSearch({
        viewId: nextViewId ?? viewId,
        sectionId: nextSectionId ?? sectionId,
        equipmentId: undefined,
      });
      return;
    }

    await openEquipmentDetails({
      equipmentId: resolvedEquipmentId,
      sectionId: nextSectionId,
      viewId: nextViewId,
      analyticsAttributes,
    });
  };

  const clearEquipmentAction = async () => {
    await closeEquipmentDetails();
  };

  const selectNextAction = async () => {
    await selectNextEquipment();
  };

  const selectPreviousAction = async () => {
    await selectPreviousEquipment();
  };

  return {
    clearEquipmentAction,
    selectEquipmentAction,
    selectNextAction,
    selectPreviousAction,
    updateSearchParams,
  };
};
